<template>
  <div>
    <el-button style="margin-right: 10px;" size="small" @click="showCommodity()">{{buttonName}}</el-button>
    <el-tag
        :key="tag.commodityId"
        v-for="tag in commodityTags"
        closable
        :disable-transitions="false"
        @close="handleTagClose(tag, commodityTags)">
      {{tag.courseName}}
    </el-tag>
    <el-dialog
        :title="title"
        :visible.sync="choseCommodity"
        :close-on-click-modal=false
        :before-close="handleClose"
    >
    
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" style="margin-bottom: 10px">
        <el-row >
          <el-col :span="5" class="cls-col">
            <el-form-item label="所属分类" prop="selectedOption">
              <el-cascader
                  expand-trigger="hover"
                  size="small"
                  change-on-select="true"
                  clearable
                  :options="categoryOptions"
                  v-model="searchData.selectedOption"
                  style="width: 100%"
                  :props="{ value: 'ccId', label: 'ccName'}"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="cls-col">
            <el-form-item label="课程名称" prop="courseName">
              <el-input v-model="searchData.courseName" placeholder="课程名称" size="small" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="cls-col">
                        <el-form-item label="状态" prop="status" >
                            <el-select v-model="searchData.commodityStatus" clearable style="width: 100%"  placeholder="状态" clearable  size="small" >
                                <el-option label="已上架" :value="1"></el-option>
                                <el-option label="已下架" :value="0"></el-option>
                                <el-option label="未上架" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
          <el-col :span="5" class="cls-col">
            <el-form-item style="margin-top: 39px">
              <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
    
      </el-form>
    
      <el-table
          :data="commodityData"
          ref="commodityList"
          :row-key="getRowKeys"
          @select="handleSelectionChange"
          border>
        <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
            prop="courseName"
            label="商品名称">
        </el-table-column>
        <el-table-column
            prop="orgName"
            label="机构">
        </el-table-column>
        <el-table-column
            prop="ccName"
            label="商品分类">
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          style="margin-top: 5px; float: right; margin-right: 10px">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectCommodity()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: '',
    props: {
      buttonName: {
        type: String,
        default: '选择商品'
      },
      title: {
        type: String,
        default: '选择商品'
      },
      categoryOptions: {
        type: Array,
        default: []
      },
      commodityList: {
        type: Array,
        default: []
      },
      searchData: {
        type: Object,
        default: {}
      },
      orgCode: {
        type: String,
        default: ''
      }
      
  },
    data() {
      return {
        choseCommodity: false,
        choseCommoditys: [],
        commodityTags:[],
        commodityData: [],
        total: 0,
        currentPage: 1,
        pageSize:10,
        choseCommoditysTepm: [],
      };
    },
    methods: {
      getRowKeys(row) {
        return row.commodityId;
      },
      showCommodity() {
        this.search();
        this.choseCommodity = true;
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      handleTagClose(tag,tags) {
        for(let choseCommodity of this.choseCommoditys) {
          if(tag.commodityId == choseCommodity.commodityId) {
            this.choseCommoditys.splice(this.choseCommoditys.indexOf(choseCommodity), 1);
          }
        }
        for(let choseCommodity of this.commodityTags) {
          if(tag.commodityId == choseCommodity.commodityId) {
            this.commodityTags.splice(this.commodityTags.indexOf(choseCommodity), 1);
          }
        }
        this.$emit('changeCommodityList', this.choseCommoditys);
        
      },
      selectCommodity() {
        this.searchData.selectedOption = [];
        this.searchData.courseName = "";
        this.commodityTags = JSON.parse(JSON.stringify(this.choseCommoditys));
        this.$emit('changeCommodityList', this.choseCommoditys);
        this.choseCommodity = false;
        console.log('choseCommoditys',this.choseCommoditys);
      },

      handleClose() {
        this.searchData.selectedOption = [];
        this.searchData.courseName = "";
        this.choseCommoditys = JSON.parse(JSON.stringify(this.choseCommoditysTepm));
        this.choseCommodity = false;
      },
      
      handleSelectionChange(commoditys, row) {
        let flag = false;
        let unChose = {};
        for(let choseCommodity of this.choseCommoditys) {
          if(row.commodityId == choseCommodity.commodityId) {
            flag = true;
            unChose = choseCommodity;
          }
        }
        if(this.choseCommoditys.length > 19 && !flag) {
          this.$message({
            type: 'info',
            message: "最多选择20个关联商品！"
          });
          this.$refs.commodityList.toggleRowSelection(row,false);
          return;
        }

        
        if(flag) {
          let index = this.choseCommoditys.indexOf(unChose);
          this.choseCommoditys.splice(index,1);
        } else {
          this.choseCommoditys.push(row);
        }
        
      },
      search(val) {
        this.searchData.orgCode = this.orgCode;
        if(this.searchData.selectedOption.length > 0) {
          this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
        } else {
          this.searchData.ccId = '';
        }
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = 10;
        let params = this.searchData;
        this.https.fetchPost('/commodityInfo/selectListAll',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            let commoditys = [];
            this.commodityData = data.data.data;
            this.$refs.commodityList.clearSelection();
            for(let commodity  of this.commodityData) {
              for(let c of this.choseCommoditys) {
                if(commodity.commodityId == c.commodityId) {
                  commoditys.push(commodity);
                }
              }
            }
            commoditys.forEach(row => {
              this.$refs.commodityList.toggleRowSelection(row);
            });
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      }
    },
    watch:{
      commodityList: function(newVal,oldVal) {
        console.log('commodityList',newVal);
       
        this.commodityTags = [];
        for(let commodity of newVal) {
          let tag = {};
          tag.courseName = commodity.recommendName;
          tag.commodityId = commodity.commodityId;
          this.commodityTags.push(tag);
        }
        this.choseCommoditys = JSON.parse(JSON.stringify(this.commodityTags));
        this.choseCommoditysTepm = JSON.parse(JSON.stringify(this.commodityTags))
      }
    },
    created: function() {
        let newVal=this.commodityList;
        this.commodityTags = [];
        for(let commodity of newVal) {
          let tag = {};
          tag.courseName = commodity.recommendName;
          tag.commodityId = commodity.recommendId;
          this.commodityTags.push(tag);
        }
        this.choseCommoditys = JSON.parse(JSON.stringify(this.commodityTags));
        this.choseCommoditysTepm = JSON.parse(JSON.stringify(this.commodityTags));
    }
};
</script>

<style scoped>
  .el-tag {
    margin-right: 5px;
  }
  .el-table__header-wrapper .el-checkbox {
    display: none
  }
</style>
